import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const services = [
  {
    category: "Accounting Services",
    title: "Records you can rely on",
    desc: "Keep your books organized, current, and ready to support day-to-day decisions.",
    tags: "Transaction Records · Reconciliation · Financial Reporting",
    img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBncmFwaHMlMjBkZXNrfGVufDB8fHx8MTc4NTQxMDIyMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    category: "Taxation",
    title: "Preparation without the scramble",
    desc: "Bring structure to tax preparation with clear records, careful review, and dependable support.",
    tags: "Tax Preparation · Document Readiness · Ongoing Support",
    img: "https://images.unsplash.com/photo-1711097383282-28097ae16b1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxmaW5hbmNpYWwlMjBncmFwaHMlMjBkZXNrfGVufDB8fHx8MTc4NTQxMDIyMHww&ixlib=rb-4.1.0&q=85",
  },
];

export const Services = () => {
  const navigate = useNavigate();
  return (
    <section id="services" data-testid="services-section" className="bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-display text-5xl md:text-7xl text-center text-[#0A0A0A] mb-16 md:mb-20"
        >
          Featured services
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-14 max-w-5xl mx-auto">
          {services.map((s, i) => (
            <motion.article
              key={s.category}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group"
            >
              <div className="overflow-hidden rounded-md mb-6">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <p className="label-tech !text-[#3B37E5] mb-4">{s.category}</p>
              <h3 className="font-display text-2xl md:text-[1.75rem] leading-tight text-[#0A0A0A] mb-3">
                {s.title}
              </h3>
              <p className="text-[#52525B] leading-relaxed mb-6 max-w-sm">{s.desc}</p>
              <p className="label-tech !text-[#9CA3AF] !text-[0.68rem]">{s.tags}</p>
            </motion.article>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            data-testid="view-all-services"
            onClick={() => navigate("/services")}
            className="group inline-flex items-center gap-2 label-tech !text-[#3B37E5] hover:!text-[#2A26D6] transition-colors"
          >
            View all services
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};
